module.exports = __webpack_public_path__ + "static/img_1484-6a2ed9ac918fb25de8e97eaae57e7ecc.webp";